import script from "./RegisteredUsers.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisteredUsers.vue?vue&type=script&lang=ts&setup=true"

import "./RegisteredUsers.vue?vue&type=style&index=0&id=0004d806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0004d806"]])

export default __exports__